export default "__VITE_ASSET__C9ANRj3___"